/*
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @author Indrajit
 */

export function getCookieClient(name: string): string | null {
  try {
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function setCookieClient(name: string, value: string, options: any = {}): void {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.expires && options.expires instanceof Date) {
    cookieString += `;expires=${options.expires.toUTCString()}`;
  }

  if (options.path) {
    cookieString += `;path=${options.path}`;
  } else {
    cookieString += `;path=/`;
  }

  if (options.domain) {
    cookieString += `;domain=${options.domain}`;
  }

  if (options.secure) {
    cookieString += `;secure`;
  }

  document.cookie = cookieString;
}

export function deleteCookieClient(name: string, path: string = "/"): void {
  const deletionDate = new Date(0);
  document.cookie = `${encodeURIComponent(name)}=;expires=${deletionDate.toUTCString()};path=${path}`;
}
